import { create } from "zustand";
import { apiClient } from "@/api/client";
import { AxiosError } from "axios";

export interface AdminStats {
  agencies: { media_agencies: number };
  people: { users: number; teams: number };
  delivery: { campaigns: number; flights: number; assets: number };
  catalog: {
    ad_categories: number;
    publishers: number;
    ad_types: number;
    languages: number;
    objectives: number;
  };
}

export interface AgencyRow {
  agency_id: string;
  agency_name: string;
  campaigns: number;
  users: number;
  teams: number;
  languages: number;
  objectives: number;
}

interface AdminStatsState {
  stats: AdminStats | null;
  byAgency: AgencyRow[] | null;
  getStats: () => Promise<void>;
  getByAgency: () => Promise<void>;
}

const useAdminStatsStore = create<AdminStatsState>((set) => ({
  stats: null,
  byAgency: null,
  getStats: async () => {
    try {
      const response = await apiClient.get("/admin/stats");
      set({ stats: response.data.data });
    } catch (error) {
      const axiosError = error as AxiosError<any>;
      const errorMessage = axiosError.response
        ? axiosError.response.data?.error ?? "Something went wrong"
        : "Something went wrong";
      throw new Error(errorMessage);
    }
  },
  getByAgency: async () => {
    try {
      const response = await apiClient.get("/admin/stats/by-agency");
      set({ byAgency: response.data.data.agencies });
    } catch (error) {
      const axiosError = error as AxiosError<any>;
      const errorMessage = axiosError.response
        ? axiosError.response.data?.error ?? "Something went wrong"
        : "Something went wrong";
      throw new Error(errorMessage);
    }
  },
}));

export default useAdminStatsStore;
